module.exports = __webpack_public_path__ + "static/media/Barmag 5a.5195f8ac.jpg";